import {
  VF_DROPDOWN,
} from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown';
import {
  VF_BUTTON_SELECTOR,
} from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import {
  VF_MULTI_SELECT,
} from 'AppSrc/core/components/forms/form-base-components/v-f-multi-select';
import displayOptionsJSON from './display-options.json';



const fieldsWithDisplayOptions = [
  VF_DROPDOWN,
  VF_BUTTON_SELECTOR,
  VF_MULTI_SELECT,
];

/*
  Some times a field may have multiple possible display options. We return the display options
  to used based on the following priority:

  1. getAllOptions
    Gets all posible display options

  2. generatedKey
    This is a key we produce and so assume it to be correct. As such we always early return for
    generatedKey, even if we return undefined as we need to be aware that there are no options
    for the key we generated

  3. id && selectedNetwork
    All fields that require displayOptions should have a displayOptions list for their id.
    However sometimes they have different displayOptions for their id if the network is
    different. We could generate a generatedKey to pass in for these displayOptions but as
    this is a pretty common trend, we just pass in selectedNetwork with id and see if we
    get something. If we do, we early return. If not, we fall back to id

  4. id
    Every field that needs displayOptions SHOULD have a displayOptions for its id, this is
    even the case for empty displayOptions such as []
*/
const getDisplayOptionsForKeyPriority = (params) => {
  const {
    generatedKey,
    selectedNetwork,
    id,
    getAllOptions,
    isIcmCrq,
    isOloCrq,
    isOLOInternational,
  } = params;

  if (getAllOptions) {
    // all display options that relate to an id start with a `${id}-` pattern. As such we can safely extract related
    // values for an id of 'customer' without also extracting the values for 'customer_impact'
    const allRelatedKeys = Object.keys(displayOptionsJSON).filter((currentFieldId) => currentFieldId.startsWith(`${id}-`));
    const relatedDisplayOptions = allRelatedKeys.map((filteredId) => displayOptionsJSON[filteredId]);
    // this is the displayOptions that we would notmally get with just the id
    const strictDisplayOptions = displayOptionsJSON[id] ? displayOptionsJSON[id] : [];

    const allDisplayOptions = [
      ...relatedDisplayOptions,
      ...strictDisplayOptions,
    ];

    let unnestedDisplayOptions = [
    ];

    allDisplayOptions.forEach((nestedDisplayOptions) => {
      // sometimes this is a string, sometimes this is an array... but we always want it to be an array
      const nestedDisplayOptionsAsArray = nestedDisplayOptions.length ? nestedDisplayOptions : [nestedDisplayOptions];

      unnestedDisplayOptions = [
        ...unnestedDisplayOptions,
        ...nestedDisplayOptionsAsArray,
      ];
    });

    return unnestedDisplayOptions;
  }

  if (generatedKey) {
    return displayOptionsJSON[generatedKey];
  }

  const isInternationCoordinator = window.localStorage.getItem('isICMCoordinator');

  if (id) {
    if (id === 'select_network' && isInternationCoordinator === 'false') {
      return displayOptionsJSON[id];
    }
    if (id === 'select_network' && isInternationCoordinator === 'true') {
      return displayOptionsJSON[`${id}_international`];
    }
  }

  if (id && selectedNetwork) {
    if (id === 'services' && isIcmCrq) {
      console.log('ICM services', isIcmCrq, id, displayOptionsJSON[`${id}-${selectedNetwork}-internationalcm`]);
      return displayOptionsJSON[`${id}-${selectedNetwork}-internationalcm`];
    }
    // to get services for international and normal olo
    if (id === 'services' && isOloCrq) {
      if (isOLOInternational === 'Yes') {
        return displayOptionsJSON[`${id}-${selectedNetwork}-olo`].filter((services) => services.value.includes('International'));
      }
      return displayOptionsJSON[`${id}-${selectedNetwork}-olo`].filter((services) => (!services.value.includes('International')));
    }
    if (displayOptionsJSON[`${id}-${selectedNetwork}`]) {
      return displayOptionsJSON[`${id}-${selectedNetwork}`];
    }
  }

  return displayOptionsJSON[id];
};

// if (id && selectedNetwork) {
//   let displayOptionsJSONData = [];
//   if (id === 'impact' && displayOptionsJSON[`${id}-${selectedNetwork}-olo`] && isOloCrq) {
//     displayOptionsJSONData = displayOptionsJSON[`${id}-${selectedNetwork}-olo`];
//   }
//   else if (displayOptionsJSON[`${id}-${selectedNetwork}`]) {
//     displayOptionsJSONData = displayOptionsJSON[`${id}-${selectedNetwork}`];
//   }
//   return displayOptionsJSONData;
// }

// return displayOptionsJSON[id];
// };


// gets the displayOptions for a field based on:
// 1. if the field already has its own display options, it uses these
// 2. if a genrated key has been provided, it uses that to find the display options from displayOptionsJSON
// 3. if there are is no generatedKey however, it'll use the components id
// fullback. []
const getDisplayOptionsToUse = (params) => {
  const {
    componentData = {},
    selectedNetwork,
    generatedKey = null,
    isIcmCrq,
    isOloCrq,
    isOLOInternational,
    // we give a warning if a generated key doesn't provide us with dropdownOptions. In most cases
    // this is helpful. However there are some cases where we expect there to be no displayOptions
    showWarning = true,
    getAllOptions,
  } = params;

  const {
    id,
    // TODO: this function returns displayOptions, it should really be taking
    // displayOptionsOverwrite as a param, but displayOptions is legacy code for now
    displayOptions,
    fieldType,
  } = componentData;

  if (displayOptions) {
    return displayOptions;
  }

  const needsDisplayOptions = fieldsWithDisplayOptions.some((field) => field === fieldType);
  // no-ops if no display options needed, this helps mute unnecessary console warnings.
  // Note: We have to check for fieldType as componentData isn't always passed in
  if (fieldType && !needsDisplayOptions) {
    return null;
  }


  // some drop downs such as 'prod-cat-two' only have options based on other drop down options. As such we generate a key for
  // them, such as 'prod-cat-two-Application' which is passed to this function. This key should always have a drop down for it
  // in the json and there should be tests to prove it
  const displayOptionsFromJSON = getDisplayOptionsForKeyPriority({
    generatedKey,
    id,
    selectedNetwork,
    getAllOptions,
    isIcmCrq,
    isOloCrq,
    isOLOInternational,
  });

  if (!displayOptionsFromJSON) {
    if (showWarning) {
      console.warn(`NO DISPLAY OPTIONS FOUND FOR generatedKey: ${generatedKey}, id-selectedNetwork: ${id}-${selectedNetwork} or id: ${id}`);
    }
    return [];
  }

  console.log('displayOptionsFromJSON', displayOptionsFromJSON);
  return displayOptionsFromJSON;
};

export {
  getDisplayOptionsToUse,
};

